import { useState } from 'react';
import API from '../utils/api';
import toast from 'react-hot-toast';

export default function SubscriptionModal({ isOpen, onClose, onSuccess, mode = 'list' }) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');

  if (!isOpen) return null;

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email');
      return;
    }

    setLoading(true);
    try {
      const { data } = await API.post('/subscriptions/create-intent', {
        billingEmail: email
      });

      toast.success('Payment required. Please complete payment in a secure window.');
      // In production, would integrate with Stripe.js
      // For now, just close the modal
      setTimeout(() => {
        onSuccess();
      }, 1500);
    } catch (err) {
      if (err.response?.data?.error === 'Already subscribed') {
        toast.success('You already have an active subscription!');
        onSuccess();
      } else {
        toast.error(err.response?.data?.error || 'Failed to start subscription');
      }
    } finally {
      setLoading(false);
    }
  };

  const message = mode === 'propose' ? 'Propose unlimited trades' : 'List unlimited items';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: 16,
          padding: 32,
          maxWidth: 500,
          width: '90%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 700, margin: 0 }}>
            Unlock Barter & Free
          </h2>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: '#999' }}
          >
            ✕
          </button>
        </div>

        <div style={{ background: '#F5F0EB', borderRadius: 12, padding: 16, marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>⭐</div>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>Unlimited Membership</h3>
          <ul style={{ margin: 0, paddingLeft: 20, fontSize: 14, color: 'var(--text-mid)', lineHeight: 1.8 }}>
            <li>Unlimited barter listings</li>
            <li>Unlimited trade proposals</li>
            <li>Unlimited free item listings</li>
            <li>Unlimited claims</li>
            <li>No per-item fees</li>
            <li>Cancel anytime</li>
          </ul>
          <div style={{ fontSize: 32, fontWeight: 700, marginTop: 16, color: 'var(--cherry)' }}>
            $20<span style={{ fontSize: 16, fontWeight: 400, color: 'var(--text-soft)' }}>/month</span>
          </div>
        </div>

        <form onSubmit={handleSubscribe}>
          <div className="form-group" style={{ marginBottom: 20 }}>
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-input"
              placeholder="billing@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: 'var(--cherry)',
              color: 'white',
              border: 'none',
              borderRadius: 10,
              fontWeight: 700,
              fontSize: 14,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              marginBottom: 12
            }}
          >
            {loading ? 'Processing...' : 'Subscribe for $20/Month'}
          </button>

          <p style={{ fontSize: 11, color: 'var(--text-soft)', textAlign: 'center', margin: 0 }}>
            Secure payment powered by Stripe • Cancel anytime
          </p>
        </form>
      </div>
    </div>
  );
}
